import React from 'react';
import { PublicFooter } from './PublicFooter';

/** Compact legal footer for auth pages. */
export function PublicMinimalFooter(props) {
  return <PublicFooter variant="minimal" {...props} />;
}

export default PublicMinimalFooter;
